var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":"","variant":"info"}},[_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}),_vm._v(" "+_vm._s(_vm.message || 'One moment, loading data.')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }